import React from "react"; 
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) { // Funkjson for å gjemme alle andre siden, hvis man ikke er en bruker hos Zinb
  // Hent bruker fra localStorage
  const user = JSON.parse(localStorage.getItem("loggedInUser"));

  // Hvis bruker finnes, vis alle andre sider (child)
  if (user) {
    return children;
  }

  // Hvis ikke bruker er logget inn, send til login-siden
  return <Navigate to="/login" replace />;
}

export default PrivateRoute;
